// ProductDetailsAddToCartOptionsAndButton
import { HasProduct, withProduct, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import AddToCartOptionsAndButton, { //Store Custom Code
//    AddToCartOptionsAndButtonStyles, //Store Custom Code
// } from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton"; //Store Custom Code
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { productDetailsFormWrapperStyles } from "@store/Themes/common/mixins/productDetails";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Store Custom Code - Start */
import useWarehouseFilterSearch from "@insite/client-framework/Common/Hooks/useWarehouseFilterSearch";
import { request } from "@insite/client-framework/Services/ApiService";
import { getProductCollectionRealTimeInventory } from "@insite/client-framework/Services/ProductServiceV2";
import translate from "@insite/client-framework/Translate";
import AddToCartOptionsAndButton, {
    AddToCartOptionsAndButtonStyles,
} from "@store/Library/Components/Toolkit/AddToCartOptionsAndButton";
import Typography, { TypographyProps } from "@store/MobiusOverrides/Typography/Typography";
import { useEffect, useState } from "react";
/* Store Custom Code - End */

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});
const mapDispatchToProps = {
    getProductCollectionRealTimeInventory,
};

export interface ProductDetailsAddToCartOptionsAndButtonStyles {
    addToCartOptionAndButton?: AddToCartOptionsAndButtonStyles;
    // Store Custom Code
    multipleQtyMessage?: TypographyProps;
}

export const productDetailsAddToCartOptionsAndButtonStyles: ProductDetailsAddToCartOptionsAndButtonStyles = {
    addToCartOptionAndButton: {
        flexWrapper: {
            extendedStyles: {
                wrapper: {
                    css: productDetailsFormWrapperStyles(),
                },
            },
        },
        quantityOrdered: {
            extendedStyles: {
                cssOverrides: {
                    inputSelect: css`
                        width: ${pxToRem(63)};
                    `,
                },
            },
        },
    },
    // Store Custom Code
    multipleQtyMessage: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
};

const styles = productDetailsAddToCartOptionsAndButtonStyles;

// const pricingAndInventory = loadProductPricingAndInventory
const ProductDetailsAddToCartOptionsAndButton = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    // Store Custom Code
    product,
}: Props) => {

    return (
        <>
            <AddToCartOptionsAndButton
                sizeVariant="default"
                buttonSizeVariant="xlarge"
                extendedStyles={{
                    ...styles.addToCartOptionAndButton,
                    unitOfMeasure: {
                        ...styles.addToCartOptionAndButton?.unitOfMeasure,
                        uid: "unit-of-measure",
                    },
                    quantityOrdered: {
                        ...styles.addToCartOptionAndButton?.quantityOrdered,
                        id: "qty-ordered",
                        configurationCompleted,
                        variantSelectionCompleted,
                    },
                    addToCartButton: {
                        ...styles.addToCartOptionAndButton?.addToCartButton,
                        configurationSelection,
                        configurationCompleted,
                        variantSelectionCompleted,
                        "data-test-selector": "addProductToCart",
                    },
                }}
                isDiscontinuedCustom={product.properties.isDiscontinuedCustom}
            />
        </>
    );
    /* Store Custom Code - End */
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsAddToCartOptionsAndButton)),
    definition: {
        displayName: "Add to Cart Options and Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        icon: "cart-circle-plus",
    },
};

export default widgetModule;
